import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-confirm-dialog-template',
  templateUrl: './confirm-dialog-template.component.html',
  styleUrls: ['./confirm-dialog-template.component.scss']
})
export class ConfirmDialogTemplateComponent implements OnInit {

  confirm ={result:true};

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { 
    this.confirm=data;
  }

  ngOnInit(): void {
  }

}
